import Nav from 'components/nav/Nav';
import { FC, ReactNode } from 'react';
import { useLocation } from 'react-router';
import { FULL_SCREEN_ROUTES } from 'shared/constants';
import Header from './Header';
import PageTitle from './PageTitle';
import PageView from './PageView';
import CustomSnackbar from './CustomSnackbar';

interface LayoutProps {
  children: ReactNode;
}

const Layout: FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const fullScreen = FULL_SCREEN_ROUTES.some((route) => currentPath.startsWith(route));

  return (
    <div className={!fullScreen ? 'page-grid' : ''}>
      {!fullScreen ? (
        <>
          <PageTitle />
          <Nav />
          <PageView />
          <Header />
        </>
      ) : <CustomSnackbar />}
      {/* CustomSnakbar is for rendering alerts in full screen */}
      {children}
    </div>
  );
};

export default Layout;
